import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { display_toggle_edge_visibility } from '../../ui_display';
import { shift_pressed } from '@frontend/keypress';
import hide_edges_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/hide_edges.svg';
import { img } from '@phi/components';
import HideEdgesTooltip from './HideEdgesTooltip';

export const HideEdgesIcon = hide_edges_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return this.coming_soon
                || this.state.editing_reference_sketches;
        },

        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show/hide edges';
        },

        selected() {
            return this.state.tut_stage === 1;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                display_toggle_edge_visibility(false, shift_pressed());
        },

        onLongClick() {
            if (this.disabled)
                return;
            else
                display_toggle_edge_visibility(false, true);
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.selected,
            active: !this.state.currently_hiding_edges,
            id: 'hide-edges-button',
            tippy: 'top',
            long: true,
            onClick: this.onClick,
            onLongClick: this.onLongClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(hide_edges_svg, this.alt),
            tooltip: HideEdgesTooltip,
        });
    }
});
